import { render, staticRenderFns } from "./YensIcon.vue?vue&type=template&id=3410f7fc&"
import script from "./YensIcon.vue?vue&type=script&lang=ts&"
export * from "./YensIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports